import { render, staticRenderFns } from "./informational-card.vue?vue&type=template&id=a19b5952"
import script from "./informational-card.vue?vue&type=script&lang=js"
export * from "./informational-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports